import {select} from "../../../../../shared/SagaService";

export function* parseTags(transaction = {}) {
    const tagGroups = yield select(state => state.List.tagGroups);

    const flattenTags = tagGroups.flatMap(tagGroup => [...tagGroup.tags]);
    const invalidTags = [];

    // eslint-disable-next-line no-param-reassign
    transaction.tag_ids = transaction.tag_ids.filter((txnTagId, idx) => {
        if (!flattenTags.find(flattenTag => flattenTag.id === txnTagId)) {
            invalidTags.push(transaction.autosave_text_values.tag_ids[idx]);
            return false;
        }
        return true;
    });

    return invalidTags;
}
